var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgB4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 109,
    viewBox: "0 0 109 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9695 2.15736C39.7408 0.402859 42.2124 -0.222537 42.8457 1.4296L48.1568 15.2899C55.0148 33.1873 73.2433 44.0538 92.2484 41.5745L106.967 39.6543C108.721 39.4256 109.347 41.8972 107.694 42.5305L93.8342 47.8416C75.937 54.6996 65.0704 72.9281 67.5498 91.9332L69.4699 106.652C69.6987 108.406 67.227 109.032 66.5937 107.379L61.2826 93.519C54.4246 75.6218 36.1962 64.7552 17.1909 67.2346L2.47255 69.1548C0.718045 69.3835 0.0926488 66.9118 1.74479 66.2786L15.6051 60.9675C33.5025 54.1094 44.369 35.881 41.8896 16.8757L39.9695 2.15736Z",
    fill: "#FFF500"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgB4);
export default __webpack_public_path__ + "static/media/b4.04edb5089650289653327466d17e1e7b.svg";
export { ForwardRef as ReactComponent };